// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1083":"2081972a","2388":"e9f440af"}[chunkId] + ".chunk.css";
};